<template>
    <div class="price-details__wrapper" :class="{'price-details__total': total}">
        <p :class="{bold}">{{ label }}</p>
        <p class="price-details__value" :class="{bold: bold}">{{ value }}</p>
    </div>
</template>

<script setup lang="ts">
    interface Props {
        label?: string;
        value?: string;
        total?: boolean;
        bold?: boolean;
    }

    withDefaults(defineProps<Props>(), {
        total: false,
        bold: false,
    });
</script>

<style lang="scss" scoped>
    .price-details {
        &__wrapper {
            display: flex;
            justify-content: space-between;
            font-weight: var(--joy-font-weight-normal);
            font-size: var(--joy-font-size-primary-300);
            line-height: var(--joy-line-height-large);

            p {
                margin-bottom: 10px;
            }
        }

        &__value {
            font-weight: var(--joy-font-weight-normal);
            font-size: var(--joy-font-size-primary-300);
        }

        &__total {
            padding: 12px;
            background: var(--joy-color-secondary-10);
            border-radius: var(--joy-core-radius-2);
            color: var(--joy-color-secondary-50);
            font-weight: var(--joy-font-weight-bold);
            margin-left: -12px !important;
            margin-right: -12px !important;
            margin-bottom: 10px;

            p {
                margin-bottom: 0;
            }
        }
    }

    .bold {
        font-weight: var(--joy-font-weight-bold);
    }
</style>
